export default __webpack_public_path__ + "static/media/agriculture.98be3ab7.png";